/* Internationalization JS */
window.g_internationalization = window.internationalization = (function() {
	var items = [],
		LANG_ENGLISH = "en",
		LANG_ESPANOL = "es",
                websiteCode = window.websiteCode;
	
	/* Load strings from JSON file*/
	function initialize() {
	   if( (websiteCode != null && websiteCode != "" && websiteCode == "ESP") || (window.location.hostname.indexOf("espanol") == 0) || (window.location.hostname.indexOf("hispanic") == 0) ) {
   		$.each( window.espInternationalization, function( key, val ) {				
   			items[key] = val;
   		});
	   }
	}

	/* Returns the stored value if any for passed in key */
	function getString(key) {
		var websiteCode = window.websiteCode;
		if( (websiteCode != null && websiteCode != "" && websiteCode == "ESP") || (window.location.hostname.indexOf("espanol") == 0) || (window.location.hostname.indexOf("hispanic") == 0) ) {
			if(key == null || key == "") {
				return key;
			}
			if(items[key] != "" && items[key] != "undefined" && items[key] != undefined) {
		       return items[key];
			} 
		}
		return key;
	}
	
	/* Translate */
	function translate(from, to, text, callback) {
		var result = "";
		var url = "/intltranslator.c21?from=" + from + "&to=" + to + "&text=" + text;
		
		$.getJSON( url, {
		   format: "json"
		}).done(function( data ) {
			callback(data.result);
		});		
	}	
	
	/* Translate Property Description */
	function translatePropertyDesc(from, to, pid, callback) {
		var result = "";
		var url = "/intltranslator.c21?from=" + from + "&to=" + to + "&pid=" + pid + "&field=0";
		
		$.getJSON( url, {
		   format: "json"
		}).done(function( data ) {
			callback(data.result);
		});		
	}		

	/* Translate Agent Profile */
	function translateAgentProfile(from, to, aid, callback) {
		var result = "";
		var url = "/intltranslator.c21?from=" + from + "&to=" + to + "&aid=" + aid + "&field=1";
		
		$.getJSON( url, {
		   format: "json"
		}).done(function( data ) {
			callback(data.result);
		});		
	}		

	/* Translate Office Profile */
	function translateOfficeProfile(from, to, oid, callback) {
		var result = "";
		var url = "/intltranslator.c21?from=" + from + "&to=" + to + "&oid=" + oid + "&field=2";
		
		$.getJSON( url, {
		   format: "json"
		}).done(function( data ) {
			callback(data.result);
		});		
	}		
	
	/* Fire on load */
    initialize();
	
	return {
		initialize: initialize,
		getString : getString,
		translate: translate,
		translatePropertyDesc: translatePropertyDesc,
		translateAgentProfile: translateAgentProfile,
		translateOfficeProfile: translateOfficeProfile
	}	
}());
